import SystemUpdate from '@/views/SystemUpdate.vue';
import verification from './verification';
import personal from './personal';
import course from './course';
import teacherManagement from './teacher-management';
import aiCourse from './ai-course';
import multimediaClassroom from './multimedia-classroom';
import ladder from './ladder';
import studentManagement from './student-management';
import practice from './practice';
import more from './more';

export default [
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
      depth: 1,
    },
  },
  {
    path: '/',
    name: 'home',
    redirect: '/learning/course',
  },
  {
    path: '/learning',
    redirect: '/learning/course',
  },
  {
    path: '/learning/:mode',
    name: 'learningPage',
    component: () => import('@/views/LearnPage.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
    },
  },

  {
    path: '/roomSetting',
    name: 'roomSetting',
    component: () => import('@/views/Personal/RoomSetting.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/systemUpdate',
    name: 'systemUpdate',
    component: SystemUpdate,
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  ...teacherManagement,
  ...verification,
  ...personal,
  ...course,
  ...aiCourse,
  ...multimediaClassroom,
  ...studentManagement,
  ...ladder,
  ...practice,
  ...more,
];
